import { closeTimeoutMS } from '@src/components/layout/modalLayout';
import { currencyToSymbol, toFixed2 } from '@src/utils/pricing';
import { t } from 'i18next';
import { toJS } from 'mobx';
import { productTypes } from './cartProductTypes';
import cartRepository from './cartRepository';

export default class CartModalPresenter {
  async loadModalState(callback, locale) {
    await cartRepository.load((cartPm) => {
      if (cartPm) {
        document.body.classList.add('ReactModal__Body--open-transition');
      } else {
        document.body.classList.remove('ReactModal__Body--open-transition');

        // fix bug when modal is closed faster than closeTimeoutMS value
        setTimeout(() => {
          document.body.classList.remove('ReactModal__Body--open-transition');
          document.body.classList.remove('ReactModal__Body--open');
        }, closeTimeoutMS);
      }

      const cartModalVm = {
        isOpen: cartPm,
      };

      callback(cartModalVm);
    }, locale);
  }

  async loadCartItems(callback, user) {
    await cartRepository.getLines((linesPm) => {
      const generateCategoryViewModels = () => {
        const categoriesViewModel = [];

        const mappersByCategory = {
          [productTypes.material.type]: (itemPm, category) => {
            return {
              id: itemPm.id,
              vm: {
                bgColor: productTypes[category].bgColor,
                authorTitle: itemPm.teacherName,
                topicLine1: itemPm.productTitle,
                price: `${toFixed2(itemPm.price)} ${
                  currencyToSymbol[itemPm.currency]
                }`,
                featuredImageUrl: itemPm.productFeaturedImageUrl,
                summaryLine1: t(productTypes[category].titleString),
                summaryLine2: itemPm.formats.join(', '),
              },
            };
          },
          [productTypes.lesson.type]: (itemPm, category) => {
            return {
              id: itemPm.id,
              vm: {
                bgColor: productTypes[category].bgColor,
                authorTitle: itemPm.teacherName,
                featuredImageUrl: itemPm.productFeaturedImageUrl,
                topicLine1: itemPm.subjects.join(', '),
                topicLine2: itemPm.title,
                topicLine3: `${t('gradeKey')}: ${itemPm.grade}`,
                topicLine4: `${t('topicKey')}: ${itemPm.topic}`,
                summaryLine1: itemPm.day
                  ? new Date(itemPm.day).toLocaleDateString(itemPm.locale, {
                      month: 'long',
                      day: 'numeric',
                    })
                  : '',
                summaryLine2:
                  itemPm.time &&
                  new Date(itemPm.day).toLocaleDateString(itemPm.locale, {
                    weekday: 'long',
                  }) + `, ${itemPm.time}`,
                price: `${toFixed2(itemPm.price)} ${
                  currencyToSymbol[itemPm.currency]
                }`,
              },
            };
          },
          [productTypes.seminar.type]: (itemPm, category) => {
            return {
              id: itemPm.id,
              vm: {
                bgColor: productTypes[category].bgColor,
                authorTitle: itemPm.teacherName,
                topicLine1: itemPm.productTitle,
                price: `${toFixed2(itemPm.price)} ${
                  currencyToSymbol[itemPm.currency]
                }`,
                featuredImageUrl: itemPm.productFeaturedImageUrl,
                summaryLine1: t(productTypes[category].titleString),
                summaryLine2: itemPm.formats.join(', '),
              },
            };
          },
        };
        Object.keys(productTypes).forEach((category) => {
          const itemsPm =
            cartRepository[`${productTypes[category].type}Items`] || [];
          const categoryVm = {
            title: t(productTypes[category].titleString),
            type: productTypes[category].type,
            hasItems: itemsPm.length > 0,
            items: itemsPm.map((itemPm) =>
              mappersByCategory[productTypes[category].type](itemPm, category)
            ),
          };
          categoriesViewModel.push(categoryVm);
        });
        return categoriesViewModel;
      };

      const viewModel = {
        title: t('cart'),
        titleCount: `(${linesPm.length})`,
        cartCount: linesPm.length,
        itemsByCategory: generateCategoryViewModels(),
        showTotalAmounts: !!linesPm.length,
        subtotalAmount: `${toFixed2(cartRepository.subtotalAmount)} ${
          currencyToSymbol[cartRepository.cartCurrency]
        }`,
        totalAmount: `${toFixed2(cartRepository.totalAmount)} ${
          currencyToSymbol[cartRepository.cartCurrency]
        }`,
        showBrowseOptions: linesPm.length === 0,
        currency: currencyToSymbol[cartRepository.cartCurrency],
      };
      callback(viewModel);
    }, user);
  }

  toggleModal() {
    cartRepository.toggleModal();
  }

  openWindow() {
    cartRepository.openWindow();
  }

  openCheckout(user, loadingCallback) {
    cartRepository.openCheckout(user, loadingCallback);
  }
  async addItemToCart({
    variantId,
    topic,
    selectedTime,
    user,
    subject,
    grade,
    forUser,
  }) {
    const items = toJS(cartRepository.allLinesInCart);
    if (this.timeAlreadyInCart(items, selectedTime, forUser)) {
      return false;
    }

    await cartRepository.addItemToCart({
      variantId,
      topic,
      selectedTime,
      user,
      subject,
      grade,
      forUser,
    });

    return true;
  }

  async removeItemFromCart({ lineId, user, loadingCallback }) {
    await cartRepository.removeItemFromCart({ lineId, user });
    if (loadingCallback) {
      loadingCallback(false);
    }
  }

  timeAlreadyInCart(items, selectedTime, forUser) {
    if (!items) {
      return false;
    }

    for (var i = 0, j = items.length; i < j; i++) {
      const item = items[i];

      const itemTime = item.time.split(':');

      if (forUser) {
        if (
          item.day == selectedTime.day &&
          itemTime[0] == selectedTime.time &&
          item.forUser == forUser
        ) {
          return true;
        }
      } else if (
        item.day == selectedTime.day &&
        itemTime[0] == selectedTime.time &&
        !item.forUser
      ) {
        return true;
      }
    }

    return false;
  }
}
